import React from "react";
import styles from "../../styles";
import { inputStyles } from "./style.js";
import Window from "../Window";

class FileEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: props.config,
      width: props.height,
      height: props.width,
      lineNumber: 1,
    };
    this.restoreValue = this.restoreValue.bind(this);
    this.calculateLines = this.calculateLines.bind(this);
    this.frame = React.createRef();
  }

  componentDidMount() {
    const frame = this.frame.current;
    if (frame) {
      const divHeight = frame.offsetHeight;
      const lineHeight = parseInt(frame.style.lineHeight);
      frame.innerText = this.props.value;
      frame.addEventListener("keydown", (e) => {
        if (e.ctrlKey) {
          if (e.which === 83) {
            e.preventDefault();
            this.props.saveFile();
          }
          return false;
        }
      });
      this.setState((state) => ({
        ...state,
        lineNumber: divHeight / lineHeight,
      }));
    } else {
      this.setState((state) => ({
        ...state,
        lineNumber: 1,
      }));
    }
  }

  restoreValue(a, b) {
    const frame = this.frame.current;
    if (frame) {
      frame.innerText = this.props.value;
      frame.addEventListener("keydown", (e) => {
        if (e.ctrlKey) {
          if (e.which === 83) {
            e.preventDefault();
            this.props.saveFile();
          }
          return false;
        }
      });
    }
    this.calculateLines();
  }

  calculateLines() {
    const frame = this.frame.current;
    if (frame) {
      const divHeight = frame.offsetHeight;
      const lineHeight = parseInt(frame.style.lineHeight) - 0.16;
      const lineNumber = divHeight / lineHeight;
      this.setState((state) => ({
        ...state,
        lineNumber,
      }));
    } else {
      this.setState((state) => ({
        ...state,
        lineNumber: 1,
      }));
    }
  }

  render() {
    const config = this.props.config;
    const lineNumbers = [];
    for (let i = 0; i < this.state.lineNumber; i++)
      lineNumbers.push(
        <div
          style={{
            ...inputStyles.lineNumber,
            height: parseInt(config.lineHeight) - 0.16,
          }}
          key={String(i)}
        >
          {String(i + 1)}
        </div>
      );
    return (
      <Window
        id={this.props.id + "_window"}
        top={0}
        left={0}
        name={
          this.props.name +
          (!this.props.editable
            ? " - [readonly]"
            : this.props.saved
            ? " ●"
            : " ○")
        }
        onClick={this.props.onFocus}
        onCancel={this.props.closeWindow}
        onResize={this.restoreValue}
      >
        <div
          style={{
            ...styles.row,
            ...inputStyles.window,
            height: this.state.height,
            width: this.state.width,
            background: config.frameColor,
            color: config.textColor,
          }}
        >
          <div
            style={{
              ...inputStyles.lineBar,
              background: config.frameColor,
              fontFamily: config.fontFamily,
              fontSize: config.fontSize,
            }}
          >
            {lineNumbers}
          </div>

          <div
            ref={(c) => {
              this.frame.current = c;
            }}
            id={this.props.id + "_editorframe"}
            style={{
              ...inputStyles.frame,
              background: config.frameColor,
              color: config.textColor,
              lineHeight: config.lineHeight,
              fontFamily: config.fontFamily,
              fontSize: config.fontSize,
            }}
            spellCheck={false}
            onInput={(e) => {
              this.calculateLines();
              this.props.onChangeText(e);
            }}
            contentEditable={this.props.editable}
          ></div>
          <div style={inputStyles.bottomBar}></div>
        </div>
      </Window>
    );
  }
}

export default FileEditor;
